import {useQuery} from 'react-query'
import { api, queryClient, useMutationQuery,} from 'base'
import {showSuccessNotification} from 'common/helpers'
import {OrgBase, Organisation} from '.'

// import {Pagination} from 'common/types'
// type UsersType = 'borrowers' | 'brokers' | 'team' | 'managers'

interface UseGetOrgsParams {
  searchKeyWords?: string;
  pageNumber?: number;
  sort?: string;
  type: 'borrower' | 'broker' | 'team';
}

export const useGetAllOnlyOrgs = ({
  type, sort
}: UseGetOrgsParams) => {
  return useQuery<any>( // useQuery<Pagination<Organisation>>(
    [ 'all-orgs-only', { type, sort } ],
    async ({signal}) => {
      const {data} = await api.get('/allOrganisation', {
        signal,
        params: {
          filter: {
            type
          },
          sort,
        },
      })
      return data
    },
    {keepPreviousData: true}
  )
}

export const useGetOrganisations = ({
  pageNumber, searchKeyWords, sort, type
}: UseGetOrgsParams) => {
  return useQuery<any>( // useQuery<Pagination<Organisation>>(
    [
      'all-orgs', 
      { type, pageNumber, searchKeyWords, sort }
    ],
    async ({signal}) => {
      const params:any = {
        filter: {
          search: searchKeyWords,
          type,
        },
        include: [
          'projectsAsBorrower',
          'projectsAsBroker',
        ],
        sort,
      }
      if (!!pageNumber) {
        params.paginate = true
        params.perPage = 10
        params.page = pageNumber
      }
      const {data} = await api.get('/organisation', {
        signal,
        params,
      })
      // console.log('api result data', data)
      return data
    },
    {keepPreviousData: true}
  )
}

export const useGetOrgDetails = ({
  uuid
}: {
  uuid: string
}) => {
  return useQuery<any>( // useQuery<Pagination<Organisation>>(
    ['org-deails', uuid],
    async ({signal}) => {
      const {data} = await api.get(`/organisation/${uuid}`, {
        signal,
        params: {
          include: [
            'projectsAsBorrower',
            'projectsAsBroker',
          ],
        },
      })
      // console.log('api result data', data)
      return data
    },
    {
      enabled: !!uuid,
      keepPreviousData: true
    }
  )
}

export const useCreateOrganisation = (
  onSuccessActions: (data?: any) => void
) => {
  return useMutationQuery<Organisation, any, OrgBase>(
    ['createOrg'],
    async (values) => {
      const result = await api.post('/organisation/create', values)
      // console.log('api result', result)
      return result.data
    },
    {
      onSuccess(data) {
        // console.log('on success', data)
        queryClient.invalidateQueries('all-orgs')
        queryClient.invalidateQueries('all-orgs-only')
        onSuccessActions(data)
        showSuccessNotification(
          `New org has been created.`
        )
      },
    }
  )
}

export const useUpdateOrganisation = (
  onSuccessActions: (data?: any) => void
) => {
  return useMutationQuery<Organisation, any, OrgBase>(
    ['updateOrg'],
    async (values) => {
      const result = await api.post('/organisation/update', values)
      // console.log('api result', result)
      return result.data
    },
    {
      onSuccess(data) {
        // console.log('on success', data)
        queryClient.invalidateQueries('all-orgs')
        queryClient.invalidateQueries('all-orgs-only')
        queryClient.invalidateQueries('org-deails')
        onSuccessActions(data)
        showSuccessNotification(
          `Org has been updated.`
        )
      },
    }
  )
}

interface UseGetOrgMembersParams {
  id?: string
}
export const useGetOrgMember = ({
  id,
}: UseGetOrgMembersParams) => {
  return useQuery(
    'team',
    async ({signal}) => {
      const {data} = await api.get('/user/list', {
        signal,
        params: {
          sort: 'firstName',
          // filter: {
          //   id
          // }
        },
      })
      // console.log(data?.data)
      return data
    },
    {keepPreviousData: true}
    // options
  )
}

export const useAssignMember = (
  orgId: string,
  action: 'update' | 'create',
  onSuccessActions: (data?: any) => void
) =>
  useMutationQuery(
    ['assign-member'],
    async (values) => {
      const {data} = await api.post(`/organisation/${orgId}/member/assign`, values)
      // console.log('api data', data)
      return data.data
    },
    {
      onSuccess(data) {
        // console.log('success data', data)
        queryClient.invalidateQueries('org-deails')
        onSuccessActions(data)
        showSuccessNotification(
          (action === 'create') ?
          `New member has been assigned.`
          :
          `Team member has been updated.`
        )
      },
    }
  )
